export default "__VITE_ASSET__spYzSGkx__"